import React from 'react';
import { FormattedMessage, type MessageDescriptor } from '@atlassian/jira-intl';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';

type Props = {
	letter: string;
	message: MessageDescriptor;
};

const KeyboardShortcutTooltip = ({ letter, message }: Props) => (
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
	<div className={styles.tooltipContainer}>
		{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
		<div className={styles.textContainer}>
			<FormattedMessage {...message} />
		</div>
		{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
		<div className={styles.shortcutContainer}>{letter}</div>
	</div>
);

export default KeyboardShortcutTooltip;
